// SYSTEM1
import { toaster } from "@/utilities/toaster";
import { assign, Machine } from "xstate";
import { PAReviewModule } from "@/store/modules/paReview.module";
const reviewMeetingDetailMachine = Machine({
    id: "reviewMeetingDetailMachine",
    context: {
        reviewId: "",
    },
    initial: "idle",
    states: {
        idle: {
            on: {
                GETTING_REVIEW_MEETING_DETAILS: { target: "getMeetingDetails", actions: "assignReviewId" },
            },
        },
        getMeetingDetails: {
            tags: "getMeetingDetails",
            invoke: {
                id: "getMeetingDetails",
                src: (context, event) => {
                    return PAReviewModule.GetReviewMeetingDetails(context.reviewId);
                },
                onDone: { target: "loadedMeetingDetails" },
                onError: { target: "serviceUnavailable" },
            },
        },
        loadedMeetingDetails: {
            initial: "idle",
            states: {
                idle: {
                    on: {
                        ADD_ACTION_ITEM: { target: "#reviewMeetingDetailMachine.loadedMeetingDetails.addActionItem" },
                        EDIT_ACTION_ITEM: { target: "#reviewMeetingDetailMachine.loadedMeetingDetails.editActionItem" },
                        START_MEETING: { target: "#reviewMeetingDetailMachine.loadedMeetingDetails.startmeeting" },
                        END_MEETING: { target: "#reviewMeetingDetailMachine.loadedMeetingDetails.endmeeting" },
                        DELETE_MEETING: { target: "#reviewMeetingDetailMachine.loadedMeetingDetails.deleteMeeting" },
                        CLOSE_MEETING: { target: "#reviewMeetingDetailMachine.loadedMeetingDetails.closeMeeting" },
                        EDIT_MEETING: { target: "#reviewMeetingDetailMachine.idle" },
                        DELETE_ACTION_ITEM: { target: "#reviewMeetingDetailMachine.loadedMeetingDetails.deleteActionItem" },
                        COMPLETING_ACTION_ITEM: { target: "#reviewMeetingDetailMachine.loadedMeetingDetails.completingActionItem" },
                        MEETING_NOTES: { target: "#reviewMeetingDetailMachine.loadedMeetingDetails.meetingNotes" },
                    },
                },
                addActionItem: {
                    tags: "showAddUi",
                    on: {
                        ADDING_ACTION_ITEM: { target: "addingActionItem" },
                        CANCEL: { target: "#reviewMeetingDetailMachine.loadedMeetingDetails.idle" },
                    },
                },
                addingActionItem: {
                    tags: ["addingActionItem", "showAddUi"],
                    invoke: {
                        id: "addingActionItem",
                        src: (context, event) => {
                            return PAReviewModule.addActionItem(event.actionItem);
                        },
                        onDone: { target: "#reviewMeetingDetailMachine.loadedMeetingDetails.idle", actions: "addActionItemSuccessMessage" },
                        onError: { target: "#reviewMeetingDetailMachine.serviceUnavailable" },
                    },
                },
                editActionItem: {
                    tags: "showEditUi",
                    on: {
                        EDITING_ACTION_ITEM: { target: "editingActionItem" },
                        CANCEL: { target: "#reviewMeetingDetailMachine.loadedMeetingDetails.idle" },
                    },
                },
                editingActionItem: {
                    tags: "showEditUi",
                    invoke: {
                        id: "addingActionItem",
                        src: (context, event) => {
                            return PAReviewModule.updateActionItem(event.actionItem);
                        },
                        onDone: { target: "#reviewMeetingDetailMachine.loadedMeetingDetails.idle", actions: "updateActionItemSuccessMessage" },
                        onError: { target: "#reviewMeetingDetailMachine.serviceUnavailable" },
                    },
                },
                deleteActionItem: {
                    tags: "showActionDeleteUi",
                    on: {
                        DELETING_ACTION_ITEM: { target: "deletingActionItem" },
                        CANCEL: { target: "#reviewMeetingDetailMachine.loadedMeetingDetails.idle" },
                    },
                },
                deletingActionItem: {
                    tags: "showActionDeleteUi",
                    invoke: {
                        id: "deletingActionItem",
                        src: (context, event) => {
                            return PAReviewModule.deleteActionItem(event.actionItemId);
                        },
                        onDone: { target: "#reviewMeetingDetailMachine.loadedMeetingDetails.idle", actions: "showSuccessMessage" },
                        onError: { target: "#reviewMeetingDetailMachine.serviceUnavailable" },
                    },
                },
                completingActionItem: {
                    tags: "showActionCompleteUi",
                    invoke: {
                        id: "completingActionItem",
                        src: (context, event) => {
                            return PAReviewModule.completeActionItem({ actionItemId: event.actionItemId, needUpdate: event.needUpdate });
                        },
                        onDone: { target: "#reviewMeetingDetailMachine.loadedMeetingDetails.idle", actions: "showSuccessMessage" },
                        onError: { target: "#reviewMeetingDetailMachine.serviceUnavailable" },
                    },
                },
                startmeeting: {
                    tags: "startmeeting",
                    invoke: {
                        id: "startmeeting",
                        src: (context, event) => {
                            return PAReviewModule.StartReviewMeeting(event.meetingId);
                        },
                        onDone: { target: "#reviewMeetingDetailMachine.loadedMeetingDetails.idle", actions: "showSuccessMessage" },
                        onError: { target: "#reviewMeetingDetailMachine.serviceUnavailable" },
                    },
                },
                endmeeting: {
                    tags: "endmeeting",
                    invoke: {
                        id: "endmeeting",
                        src: (context, event) => {
                            return PAReviewModule.EndReviewMeeting(event.meetingId);
                        },
                        onDone: { target: "#reviewMeetingDetailMachine.loadedMeetingDetails.idle", actions: "showSuccessMessage" },
                        onError: { target: "#reviewMeetingDetailMachine.serviceUnavailable" },
                    },
                },
                deleteMeeting: {
                    tags: "deleteUI",
                    on: {
                        DELETING_MEETING: { target: "deletingMeeting" },
                        CANCEL: { target: "#reviewMeetingDetailMachine.loadedMeetingDetails.idle" },
                    },
                },
                deletingMeeting: {
                    tags: ["deletingMeeting", "deleteUI"],
                    invoke: {
                        id: "deletingMeeting",
                        src: (context, event) => {
                            return PAReviewModule.deleteReviewMeeting(event.meetingId);
                        },
                        onDone: { target: "#reviewMeetingDetailMachine.idle", actions: "showdeleteMessage" },
                        onError: { target: "#reviewMeetingDetailMachine.serviceUnavailable" },
                    },
                },
                closeMeeting: {
                    tags: "closeUI",
                    on: {
                        CLOSING_MEETING: { target: "closingMeeting" },
                        CANCEL: { target: "#reviewMeetingDetailMachine.loadedMeetingDetails.idle" },
                    },
                },
                closingMeeting: {
                    tags: "closeUI",
                    invoke: {
                        id: "closingMeeting",
                        src: (context, event) => {
                            return PAReviewModule.closeReviewMeeting(event.meetingId);
                        },
                        onDone: { target: "#reviewMeetingDetailMachine.loadedMeetingDetails.idle", actions: "showSuccessMessage" },
                        onError: { target: "#reviewMeetingDetailMachine.serviceUnavailable" },
                    },
                },
                meetingNotes: {
                    tags: "meetingNotesUI",
                    on: {
                        CANCEL: { target: "#reviewMeetingDetailMachine.loadedMeetingDetails.idle" },
                    },
                },
            },
        },
        serviceUnavailable: {
            type: "final",
        },
    },
}, {
    actions: {
        showSuccessMessage: (context, event) => {
            toaster.ShowSuccess(event.data.successMessages[0]);
        },
        addActionItemSuccessMessage: (context, event) => {
            toaster.ShowSuccess("Action item has been created successfully.");
        },
        updateActionItemSuccessMessage: (context, event) => {
            toaster.ShowSuccess("Action item has been updated successfully.");
        },
        showdeleteMessage: (context, event) => {
            toaster.ShowSuccess("Review meeting has been canceled successfully.");
        },
        assignReviewId: assign({
            reviewId: (ctx, event) => {
                return event.reviewId;
            },
        }),
    },
    guards: {},
    activities: {},
    services: {},
});
export default reviewMeetingDetailMachine;
